import React, {Fragment} from "react";
import {Helmet} from "react-helmet-async";
import Header from "components/Header/Header";

export type SiteHeaders = "Header 1" | "Header 2" | "Header 3";

const SiteHeader = () => {
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const renderControlSelections = () => {
    return <></>;
  };

  const renderHeader = () => {
    let headerClassName = "shadow-sm dark:border-b dark:border-neutral-700";
    return <Header className={headerClassName} navType="MainNav2" />;
  };

  return (
    <>
      <Helmet>
        <title>Bee</title>
      </Helmet>
      {renderControlSelections()}
      {renderHeader()}
      <div ref={anchorRef} className="h-1 absolute invisible"></div>
    </>
  );
};

export default SiteHeader;
